import React from 'react';

const HeaderWithSubHeader = ({steps, step}) => {
    return <>
        <h4>{step.label}</h4>
        <p style={{
            marginTop: "-8px",
            color: "gray",
            marginLeft: "2px",
            fontSize: "16px",
            fontWeight: "400",
        }}>Step {steps.findIndex((el) => el.label === step.label) + 1} of {steps.length}</p>
    </>
};

export default HeaderWithSubHeader;